import "./Button.css";

export const Button = ({ text, className, onClick, disabled }) => {
  return (
    <button disabled={disabled} className={className} onClick={onClick}>
      {text}
    </button>
  );
};
